const hasId = (item: unknown): item is { id: string | number } =>
  !!item &&
  typeof item === "object" &&
  "id" in item &&
  (typeof item.id === "string" || typeof item.id === "number");

// By default we assume the item has an 'id' field (string by default, `TId` can be set to number). If not, a custom getItemId function should be provided.
export const defaultGetItemId = <TId extends string | number = string>(item: unknown): TId => {
  if (hasId(item)) return item.id as TId;

  // This should be caught by TypeScript at compile time but can still happen if the provided update item does not contain an identifier field.
  throw new Error("getItemId was omitted and TItem has no 'id' field.");
};
